/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from "lodash";
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { getVacationsCalculateList, getVacationsCalculateListDownloads } from "../../../apis/vacation/vacations";
import Filters from "../../../components/Filters";
import PageHeader from "../../../components/PageHeader";
import { ControlTable } from "../../../components/Table";
import useForm from "../../../hooks/useForm";
import { dateToViewFormat } from "../../../utils/date";
import { downExcelFile } from "../../../utils/download";
import { getParams } from "../../../utils/params";
import Vacation from "./Vacation";

const VacationStatus = ({ tabList, activeTab }) => {
  const { permissions, myRoleParts } = useSelector((store) => ({
    myRoleParts: store.Data.myRoleParts,
    permissions: store.Profile.permissions,
  }), shallowEqual);
  const [fields, setFields] = useState([]);
  const [open, setOpen] = useState(false)
  const [vacationData, setVacationData] = useState({})
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions))
    {
      setTargetPermission(permissions.find(p => p.code === 'ADDED_VACATION_HISTORY'))
    }
  }, [permissions])

  useEffect(() => {
    setFields([
      {
        title: "부서",
        key: "partName",
      },
      { title: "이름", key: "employeeIdx", type: 'profile' },
      {
        title: "입사일",
        key: "employeeJoinDate",
        onValue: (value) => {
          return dateToViewFormat(value);
        },
      },
      {
        title: "연차발생(유효)",
        key: "validLeaveCreateCount",
        onValue: (value) => {
          return value + "";
        },
      },
      {
        title: "사용일수(유효)",
        key: "validLeaveUsedCount",
        onValue: (value) => {
          return value + "";
        },
      },
      {
        title: "기타휴가(유효)",
        key: "validOtherCreateCount",
        onValue: (value) => {
          return value + "";
        },
      },
      {
        title: "사용일수(유효)",
        key: "validOtherUsedCount",
        onValue: (value) => {
          return value + "";
        },
      },
      {
        title: "잔여일수(유효)",
        // className: 'border-right',
        onValue: (value, fileds, datas) => {
          return datas.validLeaveCreateCount - datas.validLeaveUsedCount + datas.validOtherCreateCount - datas.validOtherUsedCount + ''
        },
      },
      // 전체에 대한 인지 이슈로 제거
      // {
      //   title: "연차발생(전체)",
      //   key: "totalLeaveCreateCount",
      //   onValue: (value) => {
      //     return value + "";
      //   },
      // },
      // {
      //   title: "사용일수(전체)",
      //   key: "totalLeaveUsedCount",
      //   onValue: (value) => {
      //     return value + "";
      //   },
      // },

      // {
      //   title: "기타휴가(전체)",
      //   key: "totalOtherCreateCount",
      //   onValue: (value) => {
      //     return value + "";
      //   },
      // },
      // {
      //   title: "사용일수(전체)",
      //   key: "totalOtherUsedCount",
      //   onValue: (value) => {
      //     return value + "";
      //   },
      // },
    ]);
  }, [myRoleParts]);

  const {
    form,
    setForm,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      partIdx: null,
      includeDeletedEmployee: false,
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = ({ term, partIdx, employeeIdxs, ...form }) => {
    if (!isEmpty(partIdx))
    {
      form.partIdx = Number(partIdx)
    }

    setIsLoading(true);
    getVacationsCalculateList(getParams(form))
      .then((res) => {
        setList(res.data.employees);
        setTotal(res.data.total);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => setIsLoading(false));
  };

  const filters = [
    {
      title: "부서",
      type: "select",
      key: "partIdx",
      options: {
        list: [
          { label: "전체", value: "" },
          ...myRoleParts.map((part) => ({ label: part.partName, value: part.idx })),
        ],
      },
    },
    {
      title: "퇴직자 포함",
      type: "checkbox",
      key: "includeDeletedEmployee",
      label: "퇴직자 포함 보기",
      checked: form.includeDeletedEmployee,
      onChange: (checked) => {
        setForm({
          ...form,
          includeDeletedEmployee: checked
        })
      }
    },
  ]

  const headerButtons = [
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const body = {
          ...form.partIdx ? { partIdx: Number(form.partIdx) } : {},
          includeDeletedEmployee: form.includeDeletedEmployee
        }

        getVacationsCalculateListDownloads(body).then((res) => {
          downExcelFile(res, '휴가 부여 현황.xlsx')
        })
      }
    },
  ];

  const rowBtnConfig = {
    rowButtons: [
      {
        label: "수정",
        type: "edit",
        action: (data) => {
          setOpen(true)
          setVacationData(data)
        },
      },
    ],
  };

  return (
    !isEmpty(targetPermission) && (
      <>
        <PageHeader
          title={"휴가 부여 현황"}
          tabList={tabList}
          activeTab={activeTab}
          buttons={headerButtons}
        />
        {!isEmpty(myRoleParts) && (
          <Filters
            isLoading={isLoading}
            filters={filters}
            submit={filterSubmit}
            form={form}
            onChange={handleOnChange}
          />
        )}
        <ControlTable
          isLoading={isLoading}
          fields={fields}
          list={list}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          total={total}
          rowBtn={targetPermission.level > 1 ? rowBtnConfig : {}}
          submit={handleSubmit}
        />
        <Vacation
          open={open}
          setOpen={setOpen}
          vacationData={vacationData}
          submit={() => submit(form)}
        />
      </>
    ));
};

export default VacationStatus;
